import React from 'react';
import { cn } from '../../../../lib/utils';
import { EmptyNotes } from '../EmptyNotes';
import { NotePreview } from '../NotePreview';
import { Loader } from '../../../../components/ui';
import { FormattedNote } from '../../../../hooks/queries/noteTypes';
import { MobileNoteSearchInput } from '../filters/MobileNoteSearchInput';

interface NotesListProps {
  notes: FormattedNote[];
  selectedNoteId: string | null;
  openNoteId: string | null;
  isLoading: boolean;
  isMobile: boolean;
  isSmallDesktop: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onNoteSelect: (note: FormattedNote) => void;
}

export function NotesList({
  notes,
  selectedNoteId,
  openNoteId,
  isLoading,
  isMobile,
  isSmallDesktop,
  searchQuery,
  onSearchChange,
  onNoteSelect
}: NotesListProps) {
  if (isLoading) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center">
        <Loader className="mb-4" />
      </div>
    );
  }

  return (
    <div className={cn('w-full p-2 box-border', isMobile && 'px-3')}>
      {/* Mobile search input - only visible on mobile */}
      {isMobile && (
        <div className="mb-4">
          <MobileNoteSearchInput 
            className="w-full" 
            value={searchQuery}
            onChange={onSearchChange}
          />
        </div>
      )}

      {notes.length === 0 ? (
        <EmptyNotes />
      ) : (
        <div className="space-y-6">
          {/* Notes grid */}
          <div
            className={`grid grid-cols-1 ${
              isMobile
                ? ''
                : isSmallDesktop
                  ? 'sm:grid-cols-2'
                  : 'sm:grid-cols-2 lg:grid-cols-3'
            } auto-rows-fr gap-5`}
          >
            {notes.map(note => (
              <div key={note.id} className="h-full min-h-[120px]">
                <NotePreview
                  note={note}
                  onClick={() => onNoteSelect(note)}
                  isActive={selectedNoteId === note.id}
                  isCurrentlyOpen={openNoteId === note.id}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}